/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { TextFormat, Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './insurance-claim-item.reducer';

export const InsuranceClaimItemDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const insuranceClaimItemEntity = useAppSelector(state => state.insuranceClaimItem.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="insuranceClaimItemDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.insuranceClaimItem.detail.title">InsuranceClaimItem</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.insuranceClaimItem.id">Id</Translate>
            </span>
          </dt>
          <dd>{insuranceClaimItemEntity.id}</dd>
          <dt>
            <span id="quantityProvided">
              <Translate contentKey="tinyMedicRestApp.insuranceClaimItem.quantityProvided">Quantity Provided</Translate>
            </span>
          </dt>
          <dd>{insuranceClaimItemEntity.quantityProvided}</dd>
          <dt>
            <span id="quantityApproved">
              <Translate contentKey="tinyMedicRestApp.insuranceClaimItem.quantityApproved">Quantity Approved</Translate>
            </span>
          </dt>
          <dd>{insuranceClaimItemEntity.quantityApproved}</dd>
          <dt>
            <span id="priceApproved">
              <Translate contentKey="tinyMedicRestApp.insuranceClaimItem.priceApproved">Price Approved</Translate>
            </span>
          </dt>
          <dd>{insuranceClaimItemEntity.priceApproved}</dd>
          <dt>
            <span id="explanation">
              <Translate contentKey="tinyMedicRestApp.insuranceClaimItem.explanation">Explanation</Translate>
            </span>
          </dt>
          <dd>{insuranceClaimItemEntity.explanation}</dd>
          <dt>
            <span id="justification">
              <Translate contentKey="tinyMedicRestApp.insuranceClaimItem.justification">Justification</Translate>
            </span>
          </dt>
          <dd>{insuranceClaimItemEntity.justification}</dd>
          <dt>
            <span id="rejectionReason">
              <Translate contentKey="tinyMedicRestApp.insuranceClaimItem.rejectionReason">Rejection Reason</Translate>
            </span>
          </dt>
          <dd>{insuranceClaimItemEntity.rejectionReason}</dd>
          <dt>
            <span id="status">
              <Translate contentKey="tinyMedicRestApp.insuranceClaimItem.status">Status</Translate>
            </span>
          </dt>
          <dd>{insuranceClaimItemEntity.status}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.insuranceClaimItem.active">Active</Translate>
            </span>
          </dt>
          <dd>{insuranceClaimItemEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.insuranceClaimItem.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>
            {insuranceClaimItemEntity.microSec ? (
              <TextFormat value={insuranceClaimItemEntity.microSec} type="date" format={APP_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.insuranceClaimItem.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>
            {insuranceClaimItemEntity.timestampEntry ? (
              <TextFormat value={insuranceClaimItemEntity.timestampEntry} type="date" format={APP_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.insuranceClaimItem.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>
            {insuranceClaimItemEntity.lastUpdated ? (
              <TextFormat value={insuranceClaimItemEntity.lastUpdated} type="date" format={APP_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.insuranceClaimItem.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{insuranceClaimItemEntity.cursor}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.insuranceClaimItem.claim">Claim</Translate>
          </dt>
          <dd>{insuranceClaimItemEntity.claim ? insuranceClaimItemEntity.claim.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/insurance-claim-item" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/insurance-claim-item/${insuranceClaimItemEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default InsuranceClaimItemDetail;
